import React from 'react';
import PropTypes from 'prop-types';
import { Button, Loader, Typography } from 'kangarootime-ui';
import Header from './Header';
import Row from './Row';
import './Row/Row.css';
import './MessagesTable.css';

// todo: center initial loader

const MessagesTable = ({
  messages,
  showLoadMore,
  performingNewQuery,
  loadingMoreFromExistingQuery,
  loadMoresMessagesUsingExistingQuery,
  ...props
}) => {
  return (
    <table className='messages-overview-container'>
      <Header />
      <tbody>
        <Loader loading={performingNewQuery}>
          { messages.length > 0
            ? messages.map(message => <Row key={message.id} message={message} />)
            : <tr className='overview-table-row'>
              <td>
                <Typography style={{ fontSize: '0.825rem' }}>No messages found for this query</Typography>
              </td>
            </tr>
          }
        </Loader>
        <tr className='flex' style={{ justifyContent: 'center', marginTop: 8 }}>
          <td>
            { showLoadMore &&
              <Loader loading={loadingMoreFromExistingQuery}>
                <Button type='ghost' onClick={loadMoresMessagesUsingExistingQuery}>Load More</Button>
              </Loader>
            }
          </td>
        </tr>
      </tbody>
    </table>
  );
};

MessagesTable.propTypes = {
  messages: PropTypes.array,
  showLoadMore: PropTypes.bool,
  performingNewQuery: PropTypes.bool,
  loadingMoreFromExistingQuery: PropTypes.bool,
  loadMoresMessagesUsingExistingQuery: PropTypes.func
};

export default MessagesTable;
